import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Import default images
import FooterShape1 from '../../../assets/images/shapes/footer-shape-1.png';
import footerLogo1 from '../../../assets/images/resources/footer-logo-1.png';
import SCLOGO1 from '../../../assets/images/resources/SCLOGO1.png';

const Footer = ({
    footerLogo = footerLogo1,
    footerShape = FooterShape1,
    footerClass = 'site-footer',
    aboutText = "At Sunrising Cinevision, our professional team is dedicated to nurturing talent while delivering high-quality production services. We help aspiring artists grow and create real opportunities in the entertainment industry.",
    contactInfo = [
        {
            icon: "icon-envolop email-icon",
            text: "info@sunrisingcinevisionacademy.in",
            link: "mailto:info@sunrisingcinevisionacademy.in"
        },
        {
            icon: "icon-envolop email-icon",
            text: "info@sunrisingcinevisionacademy.com",
            link: "mailto:info@sunrisingcinevisionacademy.com"
        },
        { icon: "icon-call phone-call", text: "+91-9983333188", link: "tel:9983333188" },
        { icon: "icon-call phone-call", text: "+91-9983333144", link: "tel:9983333144" },
        {
            icon: "icon-location location-icon",
            text: "Delhi-Chandwaji-Ajmer 200 Feet Bypass (Bilochi) Jaipur -303805",
            link: "https://maps.app.goo.gl/ZFC5YMyFFzNhKq2fA"
        },
    ],
    companyLinks = [
        { text: "Home", link: "/" },
        { text: "About Us", link: "/about" },
        { text: "Courses", link: "/courses" },
        { text: "Gallery", link: "/gallery" },
        { text: "Contact Us", link: "/contact" }
    ],
    services = [
        { name: "Complete Film Production", link: "/services" },
        { name: "Studios and Equipment for Event Shoot", link: "/services" },
        { name: "Pre & Post Wedding Shoot Venue", link: "/services" },
        { name: "Biography and Documentary Shoot Management", link: "/services" },
        { name: "Training and Podcast Shoot Management", link: "/services" }
    ],
    newsletterUrl = "MC_FORM_URL",
    newsletterText = "Stay updated with the latest news and updates from Sunrising Cinevision .",
    bottomMenu = [
        { text: "Terms & Conditions", link: "/terms" },
        { text: "Privacy Policy", link: "/privacy-policy" },
        { text: "Contact Us", link: "/contact" }
    ],

}) => {
    const [newsletterEmail, setNewsletterEmail] = useState("");
    const [responseMessage, setResponseMessage] = useState("");

    const handleNewsletterSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/newsletter/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: newsletterEmail })
            });
            if (res.ok) {
                setResponseMessage("Subscription successful");
                setNewsletterEmail("");
            } else {
                setResponseMessage("Subscription failed");
            }
        } catch (error) {
            setResponseMessage("Subscription failed");
        }
    };

    return (
        <>
            {/*Site Footer Start*/}
            <footer className={footerClass}>
                <div className="site-footer__shape-1 float-bob-y">
                    <img src={footerShape} alt="Footer Shape" />
                </div>
                <div className="site-footer__top">
                    <div className="container">
                        <div className="site-footer__top-inner">
                            <div className="row">
                                <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                                    <div className="footer-widget__column footer-widget__about">
                                        <div className="footer-widget__logo">
                                            <Link to="/">
                                                <img src={SCLOGO1} alt="Logo" width={150} height={150} />
                                            </Link>
                                        </div>
                                        <p className="footer-widget__about-text">
                                            {aboutText}
                                        </p>
                                        <ul className="footer-widget__about-contact list-unstyled">
                                            {contactInfo.map((info, index) => (
                                                <li key={index}>
                                                    <div className="icon">
                                                        <span className={info.icon} />
                                                    </div>
                                                    <p>
                                                        {info.link ? (
                                                            <a href={info.link} target="_blank" rel="noopener noreferrer">
                                                                {info.text}
                                                            </a>
                                                        ) : (
                                                            info.text
                                                        )}
                                                    </p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                                    <div className="footer-widget__column footer-widget__company">
                                        <div className="footer-widget__title-box">
                                            <h3 className="footer-widget__title">About Us</h3>
                                        </div>
                                        <ul className="footer-widget__company-list list-unstyled">
                                            {companyLinks.map((link, index) => (
                                                <li key={index}>
                                                    <Link to={link.link}>{link.text}</Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                                    <div className="footer-widget__column footer-widget__services">
                                        <div className="footer-widget__title-box">
                                            <h3 className="footer-widget__title">Services</h3>
                                        </div>
                                        <ul className="footer-widget__services-list list-unstyled">
                                            {services.map((service, index) => (
                                                <li key={index}>
                                                    <Link to={service.link}>
                                                        <span className="icon-angle-left" />
                                                        {service.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
                                    <div className="footer-widget__column footer-widget__newsletter">
                                        <div className="footer-widget__title-box">
                                            <h3 className="footer-widget__title">Newsletter</h3>
                                        </div>
                                        <p className="footer-widget__newsletter-text">
                                            {newsletterText}
                                        </p>
                                        <form onSubmit={handleNewsletterSubmit} className="footer-widget__newsletter-form mc-form" noValidate="novalidate">
                                            <div className="footer-widget__newsletter-form-input-box">
                                                <input
                                                    type="email"
                                                    placeholder="Your e-mail"
                                                    name="EMAIL"
                                                    value={newsletterEmail}
                                                    onChange={(e) => setNewsletterEmail(e.target.value)}
                                                />
                                                <button type="submit" className="footer-widget__newsletter-btn">
                                                    <span className="icon-paper-plane" />
                                                </button>
                                            </div>
                                        </form>
                                        <div className="mc-form__response">{responseMessage}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="site-footer__bottom">
                    <div className="container">
                        <div className="site-footer__bottom-inner">
                            <p className="site-footer__bottom-text">
                                © Sunrising Cinevision  {new Date().getFullYear()} | All Rights Reserved | Designed And Developed by QTNG
                            </p>
                            <ul className="list-unstyled site-footer__bottom-menu">
                                {bottomMenu.map((item, index) => (
                                    <li key={index}>
                                        <Link to={item.link}>{item.text}</Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
            {/*Site Footer End*/}
        </>
    );
}

export default Footer;
